import request from '@/utils/request'

// 计划

let PlanApi = {

  /*列表*/
  getList(data, errorback) {
    return request._post('/shop/study.plan/index', data, errorback);
  },

}

export default PlanApi;



// WEBPACK FOOTER //
// ./src/api/study/plan.js